export const ForgetPasswordOnchange_TYPE = 'SET_ForgetPasswordOnchange';
export const ForgetPasswordConstraintDataOnchange_TYPE = 'SET_ForgetPasswordConstraintDataOnchange';